// @flow
import React, { Component } from "react";
import styled from "styled-components";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import EmailIcon from "@material-ui/icons/Email";
import SendIcon from "@material-ui/icons/Send";

import * as serializeForm from "form-serialize";
import axios from "axios";

const Container = styled(Paper)`
	max-width: 500px;
	padding: 12px;
	width: 100%;
`;

const ErrorMessage = styled.div`
	border: 1px solid #f00;
	margin-top: 10px;
	padding: 5px;
`;

type Props = {};
type State = {
	form_feedback_text: string,
	form_is_submitting: boolean,
	message_sent: boolean,
};
class ContactPage extends Component<Props, State> {
	state = {
		form_feedback_text: "",
		form_is_submitting: false,
		message_sent: false,
	};
	handleSubmit = (event: any) => {
		event.preventDefault();
		event.stopPropagation();

		this.setState({
			form_feedback_text: "Sending message...",
			form_is_submitting: true,
		});

		let form_data = serializeForm(event.target, { hash: true });

		let request_data = {
			method: "post",
			url: "api/contact-us",
			data: form_data,
			headers: {
				"Content-Type": "multipart/form-data",
			},
		};
		axios(request_data)
			.then((response) => {
				this.setState({ message_sent: true });
			})
			.catch((error) => {
				this.setState({
					form_feedback_text: "Error sending message.",
					form_is_submitting: false,
				});
			});
	};

	render() {
		return (
			<Container>
				{this.state.message_sent && <div>Message Sent!</div>}
				{!this.state.message_sent && (
					<form autoComplete="nope" onSubmit={this.handleSubmit}>
						{/* This is a honeypot. It is not visible to users. Only a bot will fill it out. */}
						<TextField
							autoComplete="nope"
							style={{
								position: "absolute",
								height: "1px",
								width: "1px",
								overflow: "hidden",
							}}
							name="email"
							label="Your email address:"
							placeholder="e.g. me@example.com"
							margin="normal"
							fullWidth
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<EmailIcon />
									</InputAdornment>
								),
							}}
							disabled={this.state.form_is_submitting}
						/>

						{/* This is the real email field. */}
						<TextField
							name="liame"
							label="Your email address:"
							placeholder="e.g. me@example.com"
							margin="normal"
							fullWidth
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<EmailIcon />
									</InputAdornment>
								),
							}}
							disabled={this.state.form_is_submitting}
						/>

						<TextField
							name="message"
							label="Your message:"
							placeholder="Speak your mind..."
							margin="normal"
							fullWidth
							multiline
							rows={6}
							rowsMax={8}
							disabled={this.state.form_is_submitting}
						/>

						<Button
							type="submit"
							variant="contained"
							disabled={this.state.form_is_submitting}
						>
							<SendIcon />
							Send message
						</Button>
						{this.state.form_feedback_text && (
							<ErrorMessage>{this.state.form_feedback_text}</ErrorMessage>
						)}
					</form>
				)}
			</Container>
		);
	}
}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/pages/Contact.js